import { Route, BrowserRouter, Switch, Redirect } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Faqs from "./pages/Faqs";
import NewsRoom from "./pages/NewsRoom";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import Privacy from "./pages/PrivacyPolicy";
import Legal from "./pages/LegalTerms";
import StatutoryDetails from "./pages/StatutoryDetails";
import InvestorCorner from "./pages/InvestorCorner";
import ContactUs from "./pages/ContactUs";
import Offering from "./pages/Offerings";
import Flexicap from "./pages/LearnMore/flexicapStrategy";
import ValueStrategy from "./pages/LearnMore/valueStrategy";
import LargeCapStrategy from "./pages/LearnMore/largeCapStrategy";
import PipeStrategy from "./pages/LearnMore/pipeStartegy";
import Aif from "./pages/Aif";
import OpenAnAccount from "./pages/OpenAnAccount";
import ContraStrategy from "./pages/LearnMore/contraStrategy";
import InvestWithUs from "./pages/InvestWithUs";
import { useEffect, useState } from "react";
import AceStrategy from "./pages/LearnMore/aceStrategy";
import packgejson from "../package.json";
import SiteMap from "./pages/SiteMap";
import { Toaster } from "react-hot-toast";
import UnsubscribeEmail from "./commomComponents/Unsubscribe/unsubscribeEmail";
import { BlogContent } from "./pages/NewsRoom/blogContent";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a delay in loading the page (You can replace this with your actual loading logic)
    const delay = setTimeout(() => {
      setIsLoading(false);
    }, 5000); // 5000 milliseconds (5 seconds) delay for demonstration purposes

    // Clear the timeout when the component unmounts or when it's no longer needed
    return () => clearTimeout(delay);
  }, []);
  const version = packgejson.version;
  console.log("version", version);
  useEffect(() => {
    // Automatically refresh the page if it's taking too long to load
    if (isLoading) {
      const refreshInterval = setTimeout(() => {
        window.location.reload();
      }, 10000); // 10000 milliseconds (10 seconds) refresh interval for demonstration purposes

      // Clear the refresh timeout when the component unmounts or when it's no longer needed
      return () => clearTimeout(refreshInterval);
    }
  }, [isLoading]);
  return (
    <div className="App">
      <Toaster position="top-center" />
      {/* <div>
        <Header />
      </div> */}

      <BrowserRouter>
        {window.location.pathname !== "/unsubscribe-email" && (
          <div>
            <Header />
          </div>
        )}
        <div>
          <Switch>
            <Route exact path="/" name="Login Page" component={Home} />
            <Route
              exact
              path="/about-us"
              name="AboutUs Page"
              component={AboutUs}
            />
            <Route
              exact
              path="/portfolio-management-service"
              name="PMS Strategies"
              component={Offering}
            />
            <Route
              exact
              path="/alternative-investment-funds"
              name="Aifs"
              component={Aif}
            />
            <Route
              exact
              path="/market-insights"
              name="News Room"
              component={NewsRoom}
            />
            <Route exact path="/faqs" name="FAQs" component={Faqs} />
            <Route
              exact
              path="/investors-corner"
              name="Investor"
              component={InvestorCorner}
            />
            <Route
              exact
              path="/existing-investor"
              name="ExistingInvestor"
              component={ContactUs}
            />
            <Route
              exact
              path="/privacy-policy"
              name="Privacy"
              component={Privacy}
            />
            <Route
              exact
              path="/legal-terms"
              name="LegalTerms"
              component={Legal}
            />
            <Route
              exact
              path="/statutory-details"
              name="StatutoryDetails"
              component={StatutoryDetails}
            />
            <Route
              exact
              path="/portfolio-management-service/contrarian-investing"
              name="/LearnMore-contra"
              component={ContraStrategy}
            />
            <Route
              exact
              path="/portfolio-management-service/ace-strategy"
              name="/LearnMore-ace"
              component={AceStrategy}
            />
            <Route
              exact
              path="/portfolio-management-service/growth-leaders-strategy"
              name="/LearnMore-growth-leaders-fund"
              component={Flexicap}
            />
            <Route
              exact
              path="/portfolio-management-service/value-strategy"
              name="/LearnMore-value"
              component={ValueStrategy}
            />
            <Route
              exact
              path="/portfolio-management-service/largecap-strategy"
              name="/LearnMore-largecap"
              component={LargeCapStrategy}
            />
            <Route
              exact
              path="/portfolio-management-service/pipe-pms"
              name="/LearnMore-pipe"
              component={PipeStrategy}
            />
            {/* <Route exact path="/alternative-investment-funds" name="Aif" component={Aif} /> */}
            <Route
              exact
              path="/open-an-account"
              name="OpenAnAccount"
              component={OpenAnAccount}
            />
            <Route
              exact
              path="/invest-with-us"
              name="InvestWithUs"
              component={InvestWithUs}
            />
            <Route
              exact
              path="/unsubscribe-email"
              name="UnsubscribeEmail"
              component={UnsubscribeEmail}
              />
              <Route
               path="/insights-blogs"
               name="Insights Blogs"
               component={BlogContent}
            />
            <Route exact path="/site-map" name="Site Map" component={SiteMap} />
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </div>
        {window.location.pathname !== "/unsubscribe-email" && (
          <Footer className="Footer" />
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
